<template>
  <div :class="`position-relative h-${height}`">
    <ckeditor
      :editor="editor"
      :config="config"
      :value="value"
      v-bind="$attrs"
      v-on="$listeners"
      @ready="ready" />
    <div class="ml-4 mt-1 fw-600 wordCount" ref="wordCount" v-if="showWordCount"></div>
    <div class="mt-3" v-if="showDebugger">
      <button
        class="btn btn-sm btn-wide btn-success mr-2"
        @click="rawHTML=value">
        <font-awesome-icon :icon="['fas', 'chevron-down']" size="lg" /></button>
      <button
        class="btn btn-sm btn-wide btn-success mr-2"
        @click="value=rawHTML">
        <font-awesome-icon :icon="['fas', 'chevron-up']" size="lg" /></button>
      <button
        class="btn btn-sm btn-wide btn-danger mr-2"
        @click="clean">
        <font-awesome-icon :icon="['fas', 'trash-alt']" size="lg" /></button>
      <textarea
        class="form-control my-3"
        rows="5"
        placeholder="HTML"
        v-model="rawHTML"></textarea>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'

import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import UnderlinePlugin from '@ckeditor/ckeditor5-basic-styles/src/underline'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'

import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading'
import ListPlugin from '@ckeditor/ckeditor5-list/src/list'
import TablePlugin from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'
import WordCountPlugin from '@ckeditor/ckeditor5-word-count/src/wordcount'

const defaultPlaceholder = 'Write your text here...'
const defaultToolbarItems = ['heading', '|', 'bold', 'italic', 'underline', 'link', 'bulletedList', 'numberedList', 'insertTable', 'undo', 'redo']

export default {
  name: 'Editor',
  inheritAttrs: false,
  data () {
    return {
      editor: ClassicEditor,
      rawHTML: ''
    }
  },
  computed: {
    ...mapState(['isDevelopment']),
    config () {
      let configs = {
        plugins: [EssentialsPlugin, BoldPlugin, ItalicPlugin, UnderlinePlugin, LinkPlugin, ParagraphPlugin, HeadingPlugin, ListPlugin, TablePlugin, TableToolbar, WordCountPlugin],
        language: 'en',
        placeholder: '',
        toolbar: { items: [] },
        table: {
          contentToolbar: [
            'tableColumn', 'tableRow', 'mergeTableCells'
          ]
        },
        wordCount: {
          onUpdate: stats => {
            // console.log(`Characters: ${stats.characters}\nWords: ${stats.words}`)
            if (this.$refs && this.$refs.wordCount) {
              // eslint-disable-next-line
              this.$refs.wordCount.textContent = `${stats.characters} characters`
            }
          }
        }
      }
      configs.toolbar.items = this.toolbarItems
      configs.placeholder = this.placeholder
      return configs
    }
  },
  props: {
    validator: {
      type: Object,
      required: false
    },
    value: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      default: 350
    },
    showDebugger: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: defaultPlaceholder
    },
    toolbarItems: {
      type: Array,
      default: function () {
        return defaultToolbarItems
      }
    },
    showWordCount: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clean () {
      this.value = ''
      this.rawHTML = ''
    },
    ready () {
      // console.log(ClassicEditor.defaultConfig.toolbar)
      // console.log(ClassicEditor.builtinPlugins.map(plugin => plugin.pluginName))
    }
  }
}
</script>

<style lang="scss">
.h-100 .ck-content { height: 100px !important; }
.h-150 .ck-content { height: 150px !important; }
.h-200 .ck-content { height: 200px !important; }
.h-250 .ck-content { height: 250px !important; }
.h-300 .ck-content { height: 300px !important; }
.h-350 .ck-content { height: 350px !important; }
.wordCount {
  position: absolute;
  top: 5px;
  right: 30px;
}
</style>
